import type { AISuggestion } from '@attack100/shared';

interface AISuggestionCardProps {
  suggestion: AISuggestion;
  loading: boolean;
  onRefresh: () => void;
}

function AISuggestionCard({ suggestion, loading, onRefresh }: AISuggestionCardProps) {
  return (
    <div
      className="card"
      style={{
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        color: 'white',
        marginBottom: '2rem',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '1rem' }}>
        <div>
          <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>
            AI SUGGESTION
          </div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700' }}>
            Work on: {suggestion.angle.title}
          </h2>
        </div>
        <button
          className="btn btn-secondary"
          onClick={onRefresh}
          disabled={loading}
          style={{ flexShrink: 0 }}
        >
          {loading ? 'Loading...' : 'Refresh'}
        </button>
      </div>

      <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem', opacity: 0.95 }}>
        {suggestion.reason}
      </p>

      <div style={{ display: 'flex', gap: '2rem', fontSize: '0.875rem' }}>
        <div>
          <div style={{ opacity: 0.8, marginBottom: '0.25rem' }}>Current Progress</div>
          <div style={{ fontSize: '1.5rem', fontWeight: '700' }}>
            {suggestion.angle.current_progress.toFixed(1)}%
          </div>
        </div>
        <div>
          <div style={{ opacity: 0.8, marginBottom: '0.25rem' }}>Priority Score</div>
          <div style={{ fontSize: '1.5rem', fontWeight: '700' }}>
            {suggestion.priority_score.toFixed(1)}
          </div>
        </div>
        <div>
          <div style={{ opacity: 0.8, marginBottom: '0.25rem' }}>Last Worked</div>
          <div style={{ fontSize: '1.5rem', fontWeight: '700' }}>
            {suggestion.angle.decayed_since_hours.toFixed(0)}h ago
          </div>
        </div>
      </div>
    </div>
  );
}

export default AISuggestionCard;
